"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * Ads API
 * The Spotify Ads API.
 *
 * The version of the OpenAPI document: 3.0.0
 * Contact: selfserve-infra-api@spotify.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.CreateAssetAndGetUploadUrlRequestToJSON = exports.CreateAssetAndGetUploadUrlRequestFromJSONTyped = exports.CreateAssetAndGetUploadUrlRequestFromJSON = exports.instanceOfCreateAssetAndGetUploadUrlRequest = exports.CreateAssetAndGetUploadUrlRequestFileTypeEnum = void 0;
var runtime_1 = require("../runtime");
var AspectRatio_1 = require("./AspectRatio");
var CreateAssetRequest1_1 = require("./CreateAssetRequest1");
/**
 * @export
 */
exports.CreateAssetAndGetUploadUrlRequestFileTypeEnum = {
    Jpeg: 'JPEG',
    Mp3: 'MP3',
    Mp4: 'MP4',
    Ogg: 'OGG',
    Png: 'PNG',
    Quicktime: 'QUICKTIME',
    Wav: 'WAV'
};
/**
 * Check if a given object implements the CreateAssetAndGetUploadUrlRequest interface.
 */
function instanceOfCreateAssetAndGetUploadUrlRequest(value) {
    var isInstance = true;
    isInstance = isInstance && "fileType" in value;
    return isInstance;
}
exports.instanceOfCreateAssetAndGetUploadUrlRequest = instanceOfCreateAssetAndGetUploadUrlRequest;
function CreateAssetAndGetUploadUrlRequestFromJSON(json) {
    return CreateAssetAndGetUploadUrlRequestFromJSONTyped(json, false);
}
exports.CreateAssetAndGetUploadUrlRequestFromJSON = CreateAssetAndGetUploadUrlRequestFromJSON;
function CreateAssetAndGetUploadUrlRequestFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return __assign(__assign({}, (0, CreateAssetRequest1_1.CreateAssetRequest1FromJSONTyped)(json, ignoreDiscriminator)), { 'aspectRatio': !(0, runtime_1.exists)(json, 'aspect_ratio') ? undefined : (0, AspectRatio_1.AspectRatioFromJSON)(json['aspect_ratio']), 'fileType': json['file_type'] });
}
exports.CreateAssetAndGetUploadUrlRequestFromJSONTyped = CreateAssetAndGetUploadUrlRequestFromJSONTyped;
function CreateAssetAndGetUploadUrlRequestToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return __assign(__assign({}, (0, CreateAssetRequest1_1.CreateAssetRequest1ToJSON)(value)), { 'aspect_ratio': (0, AspectRatio_1.AspectRatioToJSON)(value.aspectRatio), 'file_type': value.fileType });
}
exports.CreateAssetAndGetUploadUrlRequestToJSON = CreateAssetAndGetUploadUrlRequestToJSON;
